import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class ComentarioApi {
  cancelTokens = {
    getComentario: null,
    getComentarios: null,
    setComentario: null,
    destroyComentario: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async destroyComentario(ocorrenciaId, comentarioId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyComentario = source;

    const { data } = await axiosInstance.delete(
    `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrenciaId}/comentarios/${comentarioId}`,      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyComentario = null;
    return data;
  }

  async setComentario(comentario) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
  
    this.cancelTokens.setComentario = source;
  
    const formData = new FormData();
    formData.append("comentario[mensagem]", comentario.mensagem);
    formData.append("comentario[ocorrencia_id]", comentario.ocorrencia_id);
  
    let response;
  
    if (comentario.id) {
      response = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${comentario.ocorrencia_id}/comentarios/${comentario.id}`,
        formData,
        {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    } else {
      response = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${comentario.ocorrencia_id}/comentarios`,
        formData,
        {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    }
  
    this.cancelTokens.setComentario = null;
    return response.data;
  }
  
  
  async getComentarios({ ocorrencia_id, page = 1, qtd_por_pagina, nome }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getComentarios = source;

    const { data } = await axiosInstance.get(
    `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrencia_id}/comentarios?${query}`, {        cancelToken: source.token,
      }
    );

    this.cancelTokens.getComentarios = null;

    return data;
  }

  async getComentario(ocorrenciaId, comentarioId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getComentario = source;

    const { data } = await axiosInstance.get(
    `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${ocorrenciaId}/comentarios/${comentarioId}`,      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getComentario = null;

    return data;
  }

  async updateComentario(id, status) {
    const payload = {
      comentario: {
        status: status.status || status  
      }
    };
  
    const { data } = await axiosInstance.put(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/comentarios/${id}`,
      payload,
      { cancelToken: axios.CancelToken.source().token }
    );
  
    return data;
  }
  

  
  
  
}

export default ComentarioApi;
